import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { Loader } from 'components';
import NumberFormat from 'react-number-format';
import { TEXT } from 'texts';
import { TextFieldProps } from '@material-ui/core/TextField';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useTranslation } from 'react-i18next';

type CardNumberInputProps = {} & TextFieldProps;

const NumberFormatCustom = (props: { inputRef?: (el: HTMLInputElement) => void; onChange?(value: unknown): void }) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef && inputRef}
      onValueChange={(values) => {
        onChange &&
          onChange({
            currentTarget: {
              value: values.value,
            },
          });
      }}
      format={'#### #### #### ####'}
    />
  );
};

const CardNumberInput: React.FC<CardNumberInputProps> = ({disabled}) => {
  const { t } = useTranslation();
  const { formStore } = useStores();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formStore.cardNumber.setValue(event.currentTarget.value);
  };

  const handleBlur = () => {
    formStore.cardNumber.validate();
  };

  const renderHelperText = () => {
    if (formStore.cardNumber.error) {
      return t(formStore.cardNumber.error);
    }
    return ' ';
  };

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="credit-number" shrink>
        {t(TEXT.cardNumber)}
      </InputLabel>
      <Input
        id="credit-number"
        name="credit-number"
        inputComponent={NumberFormatCustom}
        inputMode="numeric"
        placeholder="0000 0000 0000 0000"
        type="tel"
        value={formStore.cardNumber.value}
        onChange={handleChange}
        onBlur={handleBlur}
        endAdornment={formStore.cardNumber.isLoading && <Loader type="circular" />}
        disabled={disabled || formStore.cardNumber.isLoading}
      />
      <FormHelperText id="credit-number-helper" error={!!formStore.cardNumber.error}>
        {renderHelperText()}
      </FormHelperText>
    </FormControl>
  );
};

export default observer(CardNumberInput);
